module.exports = __webpack_public_path__ + "static/img/erweimanews.9307ccb3.png";